import React from 'react';
import { styled } from 'linaria/react';
import MaxWidth from '../../Layout/MaxWidth';
import { theme } from '../../Theme';
import { PaginatedSlider } from './PaginatedSlider';

const OuterWrapper = styled(MaxWidth)`
  ${theme.below.lg} {
    padding: 0 10px;
  }
`;

const Container = styled('div')`
  .product-card {
    margin: 0;
  }

  h1 {
    font-family: ${theme.fonts.primary};
    font-size: 28px;
    line-height: 34px;
    font-weight: 500;
    text-align: center;
    margin: 16px 0;
    color: ${(props) => props.titlecolor};
  }
  h2 {
    font-family: ${theme.fonts.primary};
    font-size: 60px;
    line-height: 60px;
    font-weight: 700;
    text-align: center;
    margin: 0;
    margin-bottom: 20px;
  }
  h3 {
    font-family: ${theme.fonts.primary};
    font-size: 24px;
    line-height: 29px;
    font-weight: 700;
    text-align: center;
    margin: 0;
  }

  [data-testid='product'] {
    width: 100%;
  }

  .mastarpris {
    .productcard {
      .productcard {
        display: none;
      }
    }
  }

  [data-flight-image-container] {
    border-radius: 10px 10px 0 0;
  }
  .color-boxes-wrapper {
    border-radius: 0 0 10px 10px;
  }
`;

export const StartPageProductRow = ({
  children,
  title,
  titleColor,
  showLipscoreRating,
}) => {
  const ratingCheckedChildren = children?.map((child) => {
    return { ...child, props: { ...child.props, showLipscoreRating } };
  });
  return (
    <OuterWrapper>
      <Container titlecolor={titleColor?.value ?? '#000'}>
        {title?.value && <h1>{title?.value}</h1>}
        <PaginatedSlider>{ratingCheckedChildren}</PaginatedSlider>
      </Container>
    </OuterWrapper>
  );
};
